"use client";

import { useState, useEffect } from "react";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

export function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-card">
      <div className="container max-w-7xl mx-auto px-4 md:px-6 py-3 flex items-center justify-start gap-4">
        <p className="text-sm text-foreground-secondary">
          Мы используем cookies для улучшения вашего опыта. Продолжая
          пользоваться сайтом, вы соглашаетесь с{" "}
          <Link
            href="/privacy"
            className="text-primary hover:text-primary/80 underline underline-offset-4 transition-colors"
          >
            политикой конфиденциальности
          </Link>
          .
        </p>
        <Button size="sm" className="bg-foreground text-background hover:bg-foreground/90 shrink-0" onClick={handleAccept}>
          Принять
        </Button>
      </div>
    </div>
  );
}
